'use client';

import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';

export const ClientDate: React.FC<{ formatString?: string }> = ({ formatString = 'EEEE, MMMM do' }) => {
  const [label, setLabel] = useState<string | null>(null);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setLabel(format(new Date(), formatString));
  }, [formatString]);

  if (label === null) {
    return null;
  }

  return <>{label}</>;
};
